import React from "react";
import Dropdown from "components/v2/Dropdown/Dropdown";

type FilterProps = {
  /**
   * Current timeframe applied
   */
  timeFrame: number;
  /**
   * Function to set the current filters
   */
  setTimeFrame: Function;
};

// TODO - Implement the DateFilter component, require backend changes

function DateFilter({ timeFrame, setTimeFrame }: FilterProps) {
  return (
    <div className="mr-lg">
      <Dropdown
        options={[
          { label: "Created in last 1 month", value: 1 },
          { label: "Created in last 3 months", value: 3 },
        ]}
        onSelect={(value) => setTimeFrame(value)}
        value={timeFrame}
      />
    </div>
  );
}

export default DateFilter;
